import { render, staticRenderFns } from "./DynamicFormModal.vue?vue&type=template&id=444d695a"
import script from "./DynamicFormModal.vue?vue&type=script&lang=js"
export * from "./DynamicFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports